import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { PatientInvoiceable, PatientVisit, SiteInvoiceable } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type PatientProtocolModel = getEntityType<PatientProtocolState>;

export type PatientProtocolState = EntityState<
  | RequireSome<Partial<PatientInvoiceable>, 'id' | 'name' | 'order_by' | 'patient_protocol_type'>
  | RequireSome<Partial<PatientVisit>, 'id' | 'name' | 'order_by' | 'patient_protocol_type'>
  | RequireSome<Partial<SiteInvoiceable>, 'id' | 'name' | 'patient_protocol_type'>
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'patient-protocol' })
export class PatientProtocolStore extends EntityStore<PatientProtocolState> {
  constructor() {
    super({});
  }
}
